import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState } from "react";
import axios from "../../../../../api/axios";
import { useNavigate } from "react-router-dom";

const newRestaurantUrl = "businessEntities/addBusinessEntity";

const New = ({ inputs, title }) => {
  const [formData, setFormData] = useState({});
  const [file, setFile] = useState("");
  const navigate = useNavigate();

  const handleChange = (e, id) => {
    const { value, type, checked } = e.target;
    const val = type === "radio" ? (checked ? value : null) : value;
    setFormData((prev) => ({
      ...prev,
      [id]: val,
    }));
  };

  const submitRequest = async (e) => {
    e.preventDefault();
    if (title === "Add New Restaurant/Hotel") {
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      try {
        const result = await axios.post(
          newRestaurantUrl,
          {
            Business_type: formData[0],
            businessEntityId: userData.businessEntityId,
            businessName: formData[1],
            Email: formData[2],
            contactNo: formData[3],
            Address: formData[4],
            country: formData[5],
            Group_ID: userData.Group_ID,
            GstNumber: formData[6],
          },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: false,
          }
        );
        if (result.status === 200) {
          navigate("/config/restaurants");
        }
      } catch (error) {
        console.error("Error adding restaurant:", error);
      }
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt=""
            />
          </div>
          <div className="right">
            <form onSubmit={submitRequest}>
              <div className="formInput">
                <label htmlFor="file">
                  Upload Logo <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div>

              {inputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  {input.type === "radio" ? (
                    <div className="radio-group">
                      {input.options.map((option) => (
                        <div key={option.value} className="radio-option">
                          <input
                            type="radio"
                            id={`${input.id}-${option.value}`}
                            name={input.name}
                            value={option.value}
                            checked={formData[input.id] === option.value}
                            onChange={(e) => handleChange(e, input.id)}
                          />
                          <label htmlFor={`${input.id}-${option.value}`}>
                            {option.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <input
                      type={input.type}
                      placeholder={input.placeholder}
                      value={formData[input.id] || ""}
                      onChange={(e) => handleChange(e, input.id)}
                    />
                  )}
                </div>
              ))}
              <button type="submit">Save Restaurant</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
